var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity-card-documents-list')
}
var staticRenderFns = []

export { render, staticRenderFns }